import axios from "axios";
import debounce from "lodash/debounce";
import { execute } from "./../../features/lazy-load";
import epica from "../../features/epica";
export const podcastMixin = {
    methods: {
        toggleShare: function (idx) {
            const aa = this.a;
            aa[idx.toString()] = !aa[idx.toString()]
            this.a = Object.assign({}, this.a, aa);
        },
    },
    data: function () {
        return {
            a: {}
        };
    }
};


export const podcastListingMixin = {
    created: function () {
        this.show = document.getElementById("podcast").dataset.showId;
    },
    updated: function() {
      execute();
      epica();
    },
    methods: {
        toggleShare: function (idx) {
            const aa = this.a;
            aa[idx.toString()] = !aa[idx.toString()]
            this.a = Object.assign({}, this.a, aa);
        },
        autocomplete: debounce(
            function () {
                this.searching = true;
                const _self = this;
                if (this.isSearch) {
                    axios.get('/api/podcast/ac', {
                            params: this.params
                        })
                        .then(function (d) {
                            _self.acResult = d.data;
                            _self.searching = false;
                        });
                }
            },
            250
        ),
        clearTopic: function () {
            this.topic = "";
            this.acResult = [];
        }
    },
    computed: {
        params: function () {
            return {
                show: this.show,
                term: this.topic,
                podcastDate: this.filterDate
            };
        },
        isSearch: function() {
            return this.topic || this.filterDate;
        }
    },
    data: function () {
        return {
            a: {},
            topic: '',
            filterDate: null,
            acResult: [],
            searching: false
        };
    }
};